export default {
  'register.title': '会员注册',
  'register.phone': '手机号',
  'register.phone.required': '请输入手机号',
  'register.phone.format': '请输入以04开头的澳洲手机号',
  'register.phone.placeholder': '请输入手机号（例如：0412345678）',
  'register.phone.verify': '验证码',
  'register.phone.verify.get': '获取验证码',
  'register.phone.verify.required': '请输入验证码',
  'register.phone.verify.sent': '验证码发送成功',
  'register.phone.verify.failed': '验证码发送失败',
  'register.phone.verify.invalid': '验证码无效',
  'register.firstName': '名',
  'register.firstName.required': '请输入名字',
  'register.middleName': '中间名',
  'register.lastName': '姓',
  'register.lastName.required': '请输入姓氏',
  'register.email': '邮箱',
  'register.email.placeholder': '选填',
  'register.email.placeholder.required': '请输入邮箱',
  'register.email.required': '请输入邮箱',
  'register.email.invalid': '请输入有效的邮箱地址',
  'register.birthday': '生日',
  'register.birthday.placeholder': '选择生日',
  'register.ageGroup': '年龄段',
  'register.ageGroup.required': '请选择年龄段',
  'register.ageGroup.placeholder': '请选择您的年龄段',
  'register.ageGroup.under-18': '小于18岁',
  'register.ageGroup.18-25': '18-25岁',
  'register.ageGroup.26-35': '26-35岁',
  'register.ageGroup.36-45': '36-45岁',
  'register.ageGroup.46-55': '46-55岁',
  'register.ageGroup.56-65': '56-65岁',
  'register.ageGroup.65+': '65岁以上',
  'register.password': '密码',
  'register.password.required': '请输入密码',
  'register.password.min': '密码长度不能少于6位',
  'register.password.max': '密码长度不能超过16位',
  'register.password.confirm': '确认密码',
  'register.password.confirm.required': '请确认密码',
  'register.password.confirm.mismatch': '两次输入的密码不一致',
  'register.submit': '注册',
  'register.success': '注册成功',
  'register.fail': '注册失败，请重试',
};
